module.exports = __webpack_public_path__ + "img/logo-caza-do-sport.1cd869d7.svg";